import { getMedicalRefundList } from '@/api';
import ExcelReceiptImage from '@/components/MedicalAirport/ExcelReceiptImage';
import ReceiptLayout from '@/components/MedicalReceipt/ReceiptLayout';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { IMedicalRefund } from '@/types/common.type';
import { MEDICAL_AIRPORT_ITEM } from '@repo/types';
import { format } from 'date-fns';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router';
import styled from 'styled-components';

const MedicalAirportReceipt = () => {
  const location = useLocation<{ displays: MEDICAL_AIRPORT_ITEM[] }>();
  const items = location.state ? location.state.displays : [];

  const { passportNumber, nationality } = useAppSelector(
    (state) => state,
  ) as IGlobalState;

  const { data } = useQuery(
    ['AirportReceiptList'],
    () => (!!passportNumber ? getMedicalRefundList(passportNumber) : null),
    { enabled: !!passportNumber },
  );

  return (
    <ReceiptLayout hasPadding={false}>
      <Title>
        {nationality === 'KOR' ? '나의 택스리펀 영수증' : 'My Receipts'}
      </Title>
      {data && (
        <RefundItemList>
          {data.map((item: IMedicalRefund, index: number) => {
            const defaultInfo = items.find(
              (i) => i.refundIndex === item.refundIndex,
            );
            const info = {
              hospitalName: item.hospitalName,
              refundIndex: item.refundIndex,
              supplyDate: item.supplyDate || format(new Date(), 'yyyy-MM-dd'),
              price: item.price || 0,
              refund: item.refund || 0,
              receiptPath: item.receiptPath || '',
              mainProductType: item.mainProductType || 0,
            };
            return (
              <ExcelReceiptImage
                {...info}
                key={`${item.refundIndex}-${index}`}
                touristIndex={item.touristIndex}
                billItem={{
                  refundStatus: '',
                  refundedIn: 'UNKNOWN',
                  serialNumber: '',
                  hospitalName: item.hospitalName,
                  refundIndex: item.refundIndex,
                  supplyDate: item.supplyDate,
                  refundAmount: item.refund,
                  totalAmount: item.price,
                  touristIndex: item.touristIndex,
                  ...defaultInfo,
                }}
              />
            );
          })}
        </RefundItemList>
      )}
    </ReceiptLayout>
  );
};

const Title = styled.h2`
  width: 100%;
  padding: 12px 20px 20px 20px;
  color: #3a3b3e;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  box-shadow: 0px 4px 4px 0px rgba(216, 216, 216, 0.25);
  background-color: #fff;
  z-index: 1;
`;

const RefundItemList = styled.div`
  width: 100%;
  align-items: center;
  flex-direction: 'column-reverse';
  padding: 20px;
`;

export default MedicalAirportReceipt;
